import { Component, OnInit } from '@angular/core';
import { Assignors, Auth } from 'src/app/models/auth';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { AssignorResponse } from 'src/app/models/cedente';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { CedenteService } from 'src/app/services/cedente.service';

import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GrantType } from 'src/app/shared/enums/grant-type.enum';
import { LoginService } from 'src/app/services/login.service';
import { Login } from 'src/app/models/login';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-select-assignor',
    templateUrl: './select-assignor.component.html',
    styleUrls: ['./select-assignor.component.css']
})
export class SelectAssignorComponent implements OnInit {

    private currentUser: Auth;
    private currentLogin: Login;

    public selectAssignorFormGroup = this.formBuilder.group({
        cedente: new FormControl('', [
            Validators.required
        ])
    });

    get form() {
        return this.selectAssignorFormGroup.controls;
    }

    get model() {
        return this.cedentes;
    }

    public cedentes: Assignors[];

    constructor(
        private formBuilder: FormBuilder,
        private alertService: NewAlertService,
        private loginService: LoginService,
        private cedenteService: CedenteService,
        private authenticationService: AuthenticationService,
        private router: Router) {
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        if(this.currentUser){
            this.currentUser.assignors.forEach(element => {element.selected = null});
            this.cedentes = this.currentUser.assignors;
        }
        else{
            this.authenticationService.logout();
            location.reload();
        }
    }

    onSubmit() {
        if (this.selectAssignorFormGroup.valid) {
           if (this.form.cedente.value !== null) {
                const cedente = this.cedentes.find(x => x.transitoryToken === this.form.cedente.value);
                cedente.selected = true;
                let i = this.currentUser.assignors.findIndex(x => x.transitoryToken === cedente.transitoryToken);
                this.currentUser.assignors[i].selected = cedente.selected;

                this.authenticationService.setCurrentUserValue(this.currentUser);

                //PEDIR PARA RETORNAR IS BLOCK
                if (cedente.blocked) {
                    this.alertService.error('Acesso bloqueado');
                    return;
                }

                if (cedente.hasPin) {

                    // charmar login para enviar o pin
                    this.authenticationService.newlogin(2,cedente.hasPin, cedente.transitoryToken).subscribe(
                        response => {
                            // pin enviado -> redirecionar para login-pin
                            if (response.status === ApiError.Sucesso) {
                                this.router.navigate(['auth/pin']);
                            } else {
                                this.alertService.error(response.message);
                            }
                        }
                    );
                } else {
                    this.authenticationService.newlogin(2,cedente.hasPin, cedente.transitoryToken).subscribe(
                        response => {
                            response.result.token.isAnonymous = false;
                            response.result.assignors = [];
                            this.cedentes.forEach(element => {response.result.assignors.push(new Assignors)});
                            this.authenticationService.setCurrentUserValue(response.result);
                            this.loginService.changeLogin(null);
                            this.router.navigate(['portal/home']);
                        }
                    )
                }
            } else {
                this.alertService.error('Ocorreu um erro ao selecionar a cedente.');
            }
        }
    }
}
